export default {
	none: 0,
	google: 1,
	microsoft: 2,
}
